import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import { matchPath } from 'react-router-dom'
import { ButtonLink } from 'components'
import classnames from 'classnames'
import {
  StepLinkType,
  BillingType,
  GiftContactType,
  DigitalRecipientType,
} from 'types'
import StepInformation from './StepInformation'

const propTypes = {
  account: PropTypes.object,
  billing: BillingType,
  billingContact: GiftContactType,
  children: PropTypes.node.isRequired,
  contact: PropTypes.object,
  giftMessage: PropTypes.string,
  membership: PropTypes.object,
  pathname: PropTypes.string.isRequired,
  recipientContact: DigitalRecipientType,
  stepLinks: PropTypes.arrayOf(StepLinkType).isRequired,
}

function ApplicationSteps({
  account = null,
  billing = null,
  billingContact = null,
  children,
  contact = null,
  giftMessage = null,
  membership = null,
  pathname,
  recipientContact = null,
  stepLinks,
}) {
  const [openStepIndex, setOpenStepIndex] = useState(0)

  const updateStepIndex = (index) => {
    // don't update if no change to avoid infinite re-renders
    if (index === openStepIndex) return
    setOpenStepIndex(index)
  }

  return stepLinks.map(({ stepName, path, stepIcon }, index) => {
    const isOpen = !!matchPath(pathname, { path, exact: true })
    if (isOpen) updateStepIndex(index)
    const isFutureStep = index > openStepIndex
    const canEdit = !isFutureStep && !isOpen

    return (
      <section
        key={stepName}
        className={classnames({
          'unavailable-step': isFutureStep,
          'completed-step': canEdit,
        })}
      >
        <div className="card">
          <header>
            <div className="card-header-container">
              <div className="card-header-info">
                <img src={stepIcon} alt="" className="icon" />
                <h3>{`${stepName}`}</h3>

                {canEdit && (
                  <ButtonLink
                    to={path}
                    aria-label={`Edit ${stepName}`}
                    className="link-primary"
                  >
                    Edit
                  </ButtonLink>
                )}
                <StepInformation
                  account={account}
                  billing={billing}
                  billingContact={billingContact}
                  canEdit={canEdit}
                  contact={contact}
                  giftMessage={giftMessage}
                  membership={membership}
                  recipientContact={recipientContact}
                  stepName={stepName}
                />
              </div>
            </div>
          </header>
          <div className="card-inner">{isOpen && children}</div>
        </div>
      </section>
    )
  })
}

ApplicationSteps.propTypes = exact(propTypes)

export default pure(ApplicationSteps)
